import ToastMessage from './ToastMessage.view';

export default ToastMessage;
